




















import Vue from "vue";
import Boarding from "./Boarding.vue";
import Intro from "./Intro.vue";
import Final from "./Final.vue";
import Step from "./Step.vue";

import { commonModule } from "@/plugins/store-accessors";

interface IState {
  rect: IRect;
}
interface IRect {
  [key: string]: number;
}

export default Vue.extend({
  name: "Interactive",
  props: {
    isActive: { type: Boolean, default: false },
    ID: { type: Array as () => string[], default: () => [] },
    step: { type: Number, default: 0 },
    type: { type: String, default: "" },
    total: { type: Number, default: 0 },
    tip: { type: Object, default: () => ({}) },
    prev: { type: Function, default: () => null },
    next: { type: Function, default: () => null },
    close: { type: Function, default: () => null },
  },
  components: {
    Boarding,
    Intro,
    Step,
    Final,
  },
  data(): IState {
    return {
      rect: {
        top: document.body.scrollHeight / 2,
        bot: document.body.scrollHeight / 2,
        lft: window.innerWidth / 2,
        rgt: window.innerWidth / 2,
      },
    };
  },
  watch: {
    isActive(active: boolean) {
      if (active) this.scroller(this.rect);
    },
    ID(ids: string[]) {
      this.highlighter(ids);
    },
    rect(rect: IRect) {
      this.scroller(rect);
    },
    getInteractive() {
      this.highlighter(this.ID);
    },
  },
  computed: {
    getInteractive() {
      return commonModule.getInteractive;
    },
  },
  methods: {
    scroller(rect: IRect) {
      if (this.isActive) {
        const options: ScrollToOptions = {
          left: 0,
          top: document.body.scrollHeight - rect.bot - window.innerHeight / 2,
          behavior: "smooth",
        };
        window.scrollTo(options);
      }
    },
    highlighter(selectors: string[]) {
      const body: HTMLElement | null = document.querySelector(".main");
      const H: number = body ? body.scrollHeight : 0;
      const W: number = body ? body.scrollWidth : 0;
      const padding: number = 15;

      if (selectors && selectors.length) {
        const tops: number[] = [];
        const bots: number[] = [];
        const lefts: number[] = [];
        const rights: number[] = [];
        selectors.forEach(selector => {
          const element = document.querySelector(selector);
          if (element) {
            const rect = element.getBoundingClientRect();
            tops.push(rect.top);
            bots.push(rect.bottom);
            lefts.push(rect.left);
            rights.push(rect.right);
          }
        });

        this.rect = {
          top: window.pageYOffset + Math.min(...tops) - padding,
          bot: H - (window.pageYOffset + Math.max(...bots)) - padding,
          lft: Math.min(...lefts) - padding,
          rgt: W - Math.max(...rights) - padding,
        };
      } else {
        this.rect = {
          top: document.body.scrollHeight / 2,
          bot: document.body.scrollHeight / 2,
          lft: window.innerWidth / 2,
          rgt: window.innerWidth / 2,
        };
      }
    },
  },
});
